var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11V1L8 11V1M12 11H17M12 4C12 4.79565 12.2634 5.55871 12.7322 6.12132C13.2011 6.68393 13.837 7 14.5 7C15.163 7 15.7989 6.68393 16.2678 6.12132C16.7366 5.55871 17 4.79565 17 4C17 3.20435 16.7366 2.44129 16.2678 1.87868C15.7989 1.31607 15.163 1 14.5 1C13.837 1 13.2011 1.31607 12.7322 1.87868C12.2634 2.44129 12 3.20435 12 4Z",
    stroke: "#939393",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinea);
export default __webpack_public_path__ + "static/media/ninea.21294079f03e60d757a8b92dcf3db23d.svg";
export { ForwardRef as ReactComponent };